export enum PostOrderInstructionTypeEnum {
  Start,
  Patrol,
  End
}

export enum PostOrderInstructionSectionTypeEnum {
  Checkpoint,
  VehicleLog
}

export enum PostOrderInstructionRevisionStateEnum {
  Draft,
  Published,
  Archived
}

/** #### SUBMISSION #### */

export enum PostOrderInstructionsSectionSubmissionStateEnum {
  Todo,
  Completed,
  NotApplicable
}
